import { render, staticRenderFns } from "./WorkflowChatWorkspace.vue?vue&type=template&id=3282a58e&scoped=true"
import script from "./WorkflowChatWorkspace.vue?vue&type=script&lang=js"
export * from "./WorkflowChatWorkspace.vue?vue&type=script&lang=js"
import style0 from "./WorkflowChatWorkspace.vue?vue&type=style&index=0&id=3282a58e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282a58e",
  null
  
)

export default component.exports